/**
 * 告警和事件级别
 */
export enum AlarmOrEventLevelE {
    /** 提示 */
    INFO = '2',
    /** 警告 */
    WARNING = '3',
    /** 次要 */
    MINOR = '4',
    /** 重要 */
    MAJOR = '5',
    /** 紧急 */
    CRITICAL = '6'
}

/**
 * 告警和事件tab ID
 */
export enum AlarmAndEventTabE {
    /**
     * 告警
     */
    Alarm = 0,
    /**
     * 事件
     */
    Event = 1
}
